import { Component } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';

@Component({
  standalone: false,
  selector: 'crm-issue-resolver',
  template: '',
  styleUrls: ['issue-resolver.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CRMIssueResolverComponent {
  constructor() {}
}
